import type AccessibleFeature from '@/features/users/feature-accessibility/models/AccessibleFeature';

import type { MaybeRef } from '@vueuse/core';
import { computed, unref } from 'vue';

import useCurrentUserAccessibleFeaturesStore from './useCurrentUserAccessibleFeaturesStore';

export default function useHasAccessToFeature(feature: MaybeRef<AccessibleFeature>) {
  const currentUserAccessibleFeaturesStore = useCurrentUserAccessibleFeaturesStore();

  return computed(() => currentUserAccessibleFeaturesStore.checkIfHasAccessToFeature(unref(feature)));
}
